export const receptionistDeviceTypes = {
    loading: "LOADING_RECEPTIONISTDEVICE",
    delete: "DELETE_RECEPTIONISTDEVICE",
    loadedOne: "LOADED_RECEPTIONISTDEVICE",
    loadedMultiple: "LOADED_RECEPTIONISTDEVICES",
    success: "SUCCESS_RECEPTIONISTDEVICE",
    restore: "RESTORE_RECEPTIONISTDEVICE",
    hardDelete: "HARDDELETE_RECEPTIONISTDEVICE",
};
